export interface EmojiDataItem {
  name: string;
  unified: string;
  short_name: string;
  category: string;
  sort_order: number;
}

export const emojiData: EmojiDataItem[] = [
  // People
  { name: 'GRINNING FACE', unified: '1f600', short_name: 'grinning', category: 'People', sort_order: 1 },
  { name: 'GRINNING FACE WITH SMILING EYES', unified: '1f601', short_name: 'grin', category: 'People', sort_order: 2 },
  { name: 'FACE WITH TEARS OF JOY', unified: '1f602', short_name: 'joy', category: 'People', sort_order: 3 },
  { name: 'SMILING FACE WITH OPEN MOUTH', unified: '1f603', short_name: 'smiley', category: 'People', sort_order: 4 },
  { name: 'SMILING FACE WITH OPEN MOUTH AND SMILING EYES', unified: '1f604', short_name: 'smile', category: 'People', sort_order: 5 },
  { name: 'SMILING FACE WITH OPEN MOUTH AND COLD SWEAT', unified: '1f605', short_name: 'sweat_smile', category: 'People', sort_order: 6 },
  { name: 'SMILING FACE WITH OPEN MOUTH AND TIGHTLY-CLOSED EYES', unified: '1f606', short_name: 'laughing', category: 'People', sort_order: 7 },
  { name: 'SMILING FACE WITH HALO', unified: '1f607', short_name: 'innocent', category: 'People', sort_order: 8 },
  { name: 'SMILING FACE WITH HORNS', unified: '1f608', short_name: 'smiling_imp', category: 'People', sort_order: 9 },
  { name: 'WINKING FACE', unified: '1f609', short_name: 'wink', category: 'People', sort_order: 10 },
  { name: 'SMILING FACE WITH HEART-SHAPED EYES', unified: '1f60d', short_name: 'heart_eyes', category: 'People', sort_order: 11 },
  { name: 'SMILING FACE WITH SUNGLASSES', unified: '1f60e', short_name: 'sunglasses', category: 'People', sort_order: 12 },
  
  // Nature
  { name: 'SEE-NO-EVIL MONKEY', unified: '1f648', short_name: 'see_no_evil', category: 'Nature', sort_order: 1 },
  { name: 'HEAR-NO-EVIL MONKEY', unified: '1f649', short_name: 'hear_no_evil', category: 'Nature', sort_order: 2 },
  { name: 'SPEAK-NO-EVIL MONKEY', unified: '1f64a', short_name: 'speak_no_evil', category: 'Nature', sort_order: 3 },
  { name: 'DOG FACE', unified: '1f436', short_name: 'dog', category: 'Nature', sort_order: 4 },
  { name: 'CAT FACE', unified: '1f431', short_name: 'cat', category: 'Nature', sort_order: 5 },
  { name: 'FOUR LEAF CLOVER', unified: '2618', short_name: 'clover', category: 'Nature', sort_order: 6 },
  
  // Foods
  { name: 'GRAPES', unified: '1f347', short_name: 'grapes', category: 'Foods', sort_order: 1 },
  { name: 'MELON', unified: '1f348', short_name: 'melon', category: 'Foods', sort_order: 2 },
  { name: 'WATERMELON', unified: '1f349', short_name: 'watermelon', category: 'Foods', sort_order: 3 },
  { name: 'TANGERINE', unified: '1f34a', short_name: 'tangerine', category: 'Foods', sort_order: 4 },
  { name: 'PIZZA', unified: '1f355', short_name: 'pizza', category: 'Foods', sort_order: 5 },
  
  // Activity
  { name: 'SOCCER BALL', unified: '26bd', short_name: 'soccer', category: 'Activity', sort_order: 1 },
  { name: 'BASKETBALL AND HOOP', unified: '1f3c0', short_name: 'basketball', category: 'Activity', sort_order: 2 },
  { name: 'AMERICAN FOOTBALL', unified: '1f3c8', short_name: 'football', category: 'Activity', sort_order: 3 },
  
  // Places
  { name: 'AIRPLANE', unified: '2708', short_name: 'airplane', category: 'Places', sort_order: 1 },
  { name: 'MOUNT FUJI', unified: '1f5fb', short_name: 'mount_fuji', category: 'Places', sort_order: 2 },
  
  // Objects
  { name: 'ELECTRIC LIGHT BULB', unified: '1f4a1', short_name: 'light_bulb', category: 'Objects', sort_order: 1 },
  { name: 'LAPTOP COMPUTER', unified: '1f4bb', short_name: 'computer', category: 'Objects', sort_order: 2 },
  
  // Symbols
  { name: 'HEAVY BLACK HEART', unified: '2764', short_name: 'heart', category: 'Symbols', sort_order: 1 },
  { name: 'TWO HEARTS', unified: '1f495', short_name: 'two_hearts', category: 'Symbols', sort_order: 2 },
  
  // Flags
  { name: 'WAVING WHITE FLAG', unified: '1f3f3', short_name: 'waving_white_flag', category: 'Flags', sort_order: 1 },
  { name: 'SOUTH KOREA FLAG', unified: '1f1f0-1f1f7', short_name: 'kr', category: 'Flags', sort_order: 2 },
];
